const styles = theme => ({
  toolbarFlexStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    width: '100%',
  },
  courseTitleStyle: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#002E47',
    marginBottom: '3px',
    fontFamily: 'Inter',
  },
  textfield: {
    '& fieldset': { border: 'none' },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        border: '1px solid #002E47',
      },
      '&.Mui-focused fieldset': {
        border: '1px solid #015ffb',
      },
    },
    maxWidth: '400px',
    width: '100%',
    padding: 0,
  },
  textfieldInput: {
    color: '#002E47',
    fontFamily: 'Inter',
    fontSize: '14px',
    padding: 0,
  },
  customWidth: {
    backgroundColor: '#fff',
  },
})

export default styles
